// extracted by mini-css-extract-plugin
export default {"SpinLoding":"SpinLoding_SpinLoding__RW5mk"};